import dayjs from 'dayjs';
import RecordRTC from 'recordrtc';
import { getRandomString } from "../../utils/utils"

const initialState = {
    recorder: null,
    isRecorder: false,
    storeData: [],
    stateAt: '',
    syncData: false,
    amountSyncData: 9,
    storeDataSync: [],
    isDebugMode: String(process.env.Speech_To_Text_Mode).toLowerCase() === 'debug',
    isEnabelFeaute: String(process.env.Speech_To_Text).toLowerCase() === 'enable',
};

/**
 * 
 * @param {*} state 
 * @param {*} action 
 * @returns 
 */



const  recordAudio =  (state = initialState, action) => {
  try {
    switch (action.type) {
      case 'INIT_RECORD_AUDIO': {
        if(!state.isEnabelFeaute) return state;
        const { payload } = action;
        state.recorder = RecordRTC(payload.stream, {
          type: 'audio'
        });
        return state
      }

      case 'RECORD_CLEAR': {
        state.recorder.reset();
        state.storeDataSync = [];
        state.storeData = [];
        state.isRecorder = false;
        return state
      }
      
      case 'START_RECORD_AUDIO': {
        console.log("START_RECORD_AUDIO")
        if(!state.isEnabelFeaute) return state;
        if(!state.recorder) {
          console.log('Func not call INIT_RECORD_AUDIO');
          return;
        }
        state.isRecorder = true;
        state.startAt = dayjs().format('YYYY-MM-DDTHH:mm:ss');
        state.recorder.startRecording();
        return state;
      }

      case 'STOP_RECORD_AUDIO': {
        if(!state.isEnabelFeaute) return state;
        console.log("STOP_RECORD_AUDIO");
        if(state.isRecorder) {
           state.recorder.stopRecording(() => {
             try {
               const blob = state.recorder.getBlob();
                console.log(blob) ;
               if(blob) {
                 state.storeData.push({
                   blob,
                   fileName: `${getRandomString(5)}-${dayjs().unix()}`,
                   startAt :state.startAt,
                   endAt: dayjs().format('YYYY-MM-DDTHH:mm:ss'),
                 });
               }
               if(state.storeData.length > state.amountSyncData) {
                 state.syncData = true;
                 state.storeDataSync = state.storeData;
                 state.storeData = [];
                }
                state.recorder.reset();
                state.isRecorder = false;
               
             } catch (error) {
                console.log("Error =>" ,error.message);
             }
           });  
        }
        return state;
      }

      case 'SYNC_RECORD_AUDIO_COMPLETE': {
        if(!state.isEnabelFeaute) return state;
        state.syncData = false;
        state.storeDataSync = [];
        return state;
      }

      case 'SET_START_RECORD_AUDIO_TIME': {
        if (!state.isEnabelFeaute) return state;
        if (!state.recorder) {
            console.log('Func not call INIT_RECORD_AUDIO');
            return;
        }
        state.startAt = dayjs().format('YYYY-MM-DDTHH:mm:ss');
        return state;
    }

    default:
        return state;
      
    }
    
  } catch (error) {
    console.log("Error")
    console.log(error);
    console.log("End Error")
    return state;
  }
};

export default recordAudio;
